import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/page/login'
import Layout from '@/page/layout'

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [{ //登录
      path: '/',
      name: 'Login',
      component: Login,
      redirect: '/login'
    },
    { //登录
        path: '/login',
        name: 'Login',
        component: Login,
    },
    { //开票打印
        path: '/invoicePrint',
        name: 'invoicePrint',
        component: () =>
			import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/invoicePrint.vue"),
		meta: {
			title: "开票打印"
		},
    },
    { //申请开票列表
        path: '/invoiceApplyManageNew',
        name: 'invoiceApplyManageNew',
        component: () =>
			import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/invoiceApplyManageNew.vue"),
		meta: {
			title: "申请开票"
		},
    },{
		path: '/detailsApprovedNew',
		name: 'detailsApprovedNew',
		component: () =>
		import( /* webpackChunkName: "home" */ "@/page/contractManagement/detailsApprovedNew.vue"),
		meta: {
		title: "查看合同立项"
		},
	},

    { //主题框架
      path: '/layout',
      name: 'Layout',
      component: Layout,
      leaf: true, // 只有一个节点
      children: [{
          path: '/indexList',
          name: 'indexList',
          component: () =>
            import( /* webpackChunkName: "home" */ "@/page/indexList.vue"),
          meta: {
            title: "首页"
          },
          children:[{
              path: 'index',
              name: 'index',
              component: () =>
                import( /* webpackChunkName: "home" */ "@/page/indexManagement/index.vue"),
              meta: {
                title: "首页"
              }
            }]
        },{
			path: 'information',
			name: 'information',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/indexManagement/information.vue"),
			meta: {
			  title: "个人信息"
			},
		},{
			path: 'messageList',
			name: 'messageList',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/indexManagement/messageList.vue"),
			meta: {
			  title: "消息列表"
			},
		},
        {
          path: 'systemList',
          name: 'systemList',
          component: () =>
            import( /* webpackChunkName: "home" */ "@/page/systemManagement/systemList.vue"),
          meta: {
            title: "系统设置"
          },
          children: [
            {
              path: 'userManage',
              name: 'userManage',
              component: () =>
                import( /* webpackChunkName: "home" */ "@/page/systemManagement/userManage.vue"),
              meta: {
                title: "员工管理"
              },
            },
            {
              path: 'roleManage',
              name: 'roleManage',
              component: () =>
                import( /* webpackChunkName: "home" */ "@/page/systemManagement/roleManage.vue"),
              meta: {
                title: "角色管理"
              },
            },
            {
              path: 'addrole',
              name: 'addrole',
              component: () =>
                import( /* webpackChunkName: "home" */ "@/page/systemManagement/addrole.vue"),
              beforeEnter: (to, from, next) => {
                if (to.query.flag=='add') {
                  to.meta.title = '新增角色'
                } else {
                  to.meta.title = '编辑角色'
                }
                next()
              },
            },
            {
              path: 'positionManage',
              name: 'positionManage',
              component: () =>
                import( /* webpackChunkName: "home" */ "@/page/systemManagement/positionManage.vue"),
              meta: {
                title: "职位管理"
              },
            },{
				path: 'whiteListManage',
				name: "whiteListManage",
				component: () =>
					import ( /* webpackChunkName: "home" */ "@/page/systemManagement/whiteListManage.vue"),
				meta: {
					title: 'IP白名单'
				}
			},
          ]
        },
		{
		  path: 'businessList',
		  name: 'businessList',
		  component: () =>
		    import( /* webpackChunkName: "home" */ "@/page/businessManagement/businessList.vue"),
		  meta: {
		    title: "业务配置"
		  },
		  children: [
		    {
				path: 'sellerManage',
				name: 'sellerManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/businessManagement/sellerManage.vue"),
				meta: {
				  title: "签约公司"
				},
			  },{
				path: 'parkManage',
				name: 'parkManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/businessManagement/parkManage.vue"),
				meta: {
				  title: "园区管理"
				},
			  },{
				path: 'stageManage',
				name: 'stageManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/businessManagement/stageManage.vue"),
				meta: {
				  title: "回款阶段"
				},
			  },{
				path: 'agencyManage',
				name: 'agencyManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/businessManagement/agencyManage.vue"),
				meta: {
				  title: "代办资质"
				},
			  },{
				path: 'entrustManage',
				name: 'entrustManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/businessManagement/entrustManage.vue"),
				meta: {
				  title: "委托付款模版"
				},
			  },{
				path: 'merchantManage',
				name: 'merchantManage',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/merchantManage.vue"),
				meta: {
					title: "账号管理"
				},
			},{
				path: 'invoiceItemManage',
				name: 'invoiceItemManage',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/invoiceItemManage.vue"),
				meta: {
					title: "开票名目"
				},
			},{
				path: 'stepManage',
				name: 'stepManage',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/stepManage.vue"),
				meta: {
					title: "审批流程"
				},
			},{
				path: 'editStep',
				name: 'editStep',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/editStep.vue"),
				meta: {
					title: "编辑"
				},
			},{
				path: 'noticeManage',
				name: 'noticeManage',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/noticeManage.vue"),
				meta: {
					title: "客户公告"
				},
			},{
				path: 'noticeAdd',
				name: 'noticeAdd',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/noticeAdd.vue"),
				meta: {
					title: "新增公告"
				},
			},{
				path: 'tradeDeviation',
				name: 'tradeDeviation',
				component: () =>
					import( /* webpackChunkName: "home" */ "@/page/businessManagement/tradeDeviation.vue"),
				meta: {
					title: "经营行业"
				},
			},],
		},
		
		{
		  path: 'contractList',
		  name: 'contractList',
		  component: () =>
		    import( /* webpackChunkName: "home" */ "@/page/contractManagement/contractList.vue"),
		  meta: {
		    title: "合同管理"
		  },
		  children: [
		    {
		      path: 'approvalManage',
		      name: 'approvalManage',
		      component: () =>
		        import( /* webpackChunkName: "home" */ "@/page/contractManagement/approvalManage.vue"),
		      meta: {
		        title: "合同立项"
		      },
		    },{
		      path: 'addApproved',
		      name: 'addApproved',
		      component: () =>
		        import( /* webpackChunkName: "home" */ "@/page/contractManagement/addApproved.vue"),
		      meta: {
		        title: "新增合同立项"
		      },
		    },{
		      path: 'detailsApproved',
		      name: 'detailsApproved',
		      component: () =>
		        import( /* webpackChunkName: "home" */ "@/page/contractManagement/detailsApproved.vue"),
		      meta: {
		        title: "查看合同立项"
		      },
		    },{
		      path: 'contractManage',
		      name: 'contractManage',
		      component: () =>
		        import( /* webpackChunkName: "home" */ "@/page/contractManagement/contractManage.vue"),
		      meta: {
		        title: "合同管理"
		      },
		    },{
				path: 'templateManage',
				name: 'templateManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/templateManage.vue"),
				meta: {
				  title: "合同模版"
				},
			  },{
				path: 'gatherManage',
				name: 'gatherManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/gatherManage.vue"),
				meta: {
				  title: "信息采集"
				},
			  },{
				path: 'setUpOne',
				name: 'setUpOne',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpOne.vue"),
				meta: {
				  title: "有限公司设立"
				},
			  },{
				path: 'setUpOne_details',
				name: 'setUpOne_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpOne_details.vue"),
				meta: {
				  title: "有限公司设立查看"
				},
			  },{
				path: 'setUpTwo',
				name: 'setUpTwo',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpTwo.vue"),
				meta: {
				  title: "合伙企业设立"
				},
			  },{
				path: 'setUpTwo_details',
				name: 'setUpTwo_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpTwo_details.vue"),
				meta: {
				  title: "合伙企业设立查看"
				},
			  },{
				path: 'setUpThree',
				name: 'setUpThree',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpThree.vue"),
				meta: {
				  title: "分公司设立"
				},
			  },{
				path: 'setUpThree_details',
				name: 'setUpThree_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpThree_details.vue"),
				meta: {
				  title: "分公司设立查看"
				},
			  },{
				path: 'setUpFour',
				name: 'setUpFour',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpFour.vue"),
				meta: {
				  title: "个体工商户设立"
				},
			  },{
				path: 'setUpFour_details',
				name: 'setUpFour_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpFour_details.vue"),
				meta: {
				  title: "个体工商户设立查看"
				},
			  },{
				path: 'setUpFive',
				name: 'setUpFive',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpFive.vue"),
				meta: {
				  title: "有限公司变更"
				},
			  },{
				path: 'setUpFive_details',
				name: 'setUpFive_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpFive_details.vue"),
				meta: {
				  title: "有限公司变更查看"
				},
			  },{
				path: 'setUpSix',
				name: 'setUpSix',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpSix.vue"),
				meta: {
				  title: "有限合伙变更"
				},
			  },{
				path: 'setUpSix_details',
				name: 'setUpSix_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/contractManagement/setUpSix_details.vue"),
				meta: {
				  title: "有限合伙变更查看"
				},
			  }],
		},
		{
		  path: 'incomeList',
		  name: 'incomeList',
		  component: () =>
		    import( /* webpackChunkName: "home" */ "@/page/incomeManagement/incomeList.vue"),
		  meta: {
		    title: "回款管理"
		  },
		  children: [
		    {
		      path: 'planManage',
		      name: 'planManage',
		      component: () =>
		        import( /* webpackChunkName: "home" */ "@/page/incomeManagement/planManage.vue"),
		      meta: {
		        title: "回款计划"
		      },
		    }]
		},

		{
			path: 'invoiceList',
			name: 'invoiceList',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/invoiceList.vue"),
			meta: {
			  title: "回款开票"
			},
			children: [{
				path: 'invoiceHeaderManage',
				name: 'invoiceHeaderManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/invoiceHeaderManage.vue"),
				meta: {
				  title: "企业发票信息"
				}
			  },{
				path: 'addressManage',
				name: 'addressManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/addressManage.vue"),
				meta: {
				  title: "企业收件地址"
				}
			  },{
				path: 'serviceManage',
				name: 'serviceManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/serviceManage.vue"),
				meta: {
				  title: "开票申请"
				},
			  },{
				path: 'applyBill',
				name: 'applyBill',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/applyBill.vue"),
				meta: {
				  title: "申请开票"
				}
			  },{
				path: 'invoice',
				name: 'invoice',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/invoice.vue"),
				meta: {
				  title: "发票抬头"
				}
			  },{
				  path: 'serviceDetails',
				  name: 'serviceDetails',
				  component: () =>
					import( /* webpackChunkName: "home" */ "@/page/invoiceManagement/serviceDetails.vue"),
				  meta: {
					title: "查看"
				  },
				}]
		  },

		{
			path: 'serviceList',
			name: 'serviceList',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/serviceList.vue"),
			meta: {
			  title: "企业服务"
			},
			children: [{
				path: 'projectManage',
				name: 'projectManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/projectManage.vue"),
				meta: {
				  title: "服务项目"
				}
			  },{
				path: 'detailsProject',
				name: 'detailsProject',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/detailsProject.vue"),
				meta: {
				  title: "查看"
				}
			  },{
				path: 'workOrderManage',
				name: 'workOrderManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/workOrderManage.vue"),
				meta: {
				  title: "工单任务"
				}
			  },{
				path: 'serviceEnterprisesManage',
				name: 'serviceEnterprisesManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/serviceEnterprisesManage.vue"),
				meta: {
				  title: "个体工商户"
				}
			  },{
				path: 'addServiceEnterprises',
				name: 'addServiceEnterprises',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/addServiceEnterprises.vue"),
				meta: {
				  title: "新增"
				}
			  },{
				path: 'detailsServiceEnterprises',
				name: 'detailsServiceEnterprises',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/detailsServiceEnterprises.vue"),
				meta: {
				  title: "查看"
				}
			  },{
				path: 'invoice_details',
				name: 'invoice_details',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/invoice_details.vue"),
				meta: {
				  title: "查看"
				}
			  },{
				path: 'limitedCompany',
				name: 'limitedCompany',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/limitedCompany.vue"),
				meta: {
				  title: "有限公司"
				}
			  },{
				path: 'limitedPartnership',
				name: 'limitedPartnership',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/limitedPartnership.vue"),
				meta: {
				  title: "有限合伙企业"
				}
			  },{
				path: 'soleProprietorship',
				name: 'soleProprietorship',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/serviceManagement/soleProprietorship.vue"),
				meta: {
				  title: "个人独资企业"
				}
			  },]
		  },
		  {
			path: 'merchantInvoiceList',
			name: 'merchantInvoiceList',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/merchantInvoiceList.vue"),
			meta: {
			  title: "个体开票"
			},
			children: [{
				path: 'invoiceApplyManage',
				name: 'invoiceApplyManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/invoiceApplyManage.vue"),
				meta: {
				  title: "申请开票"
				}
			  },{
				path: 'parkInvoiceManage',
				name: 'parkInvoiceManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/parkInvoiceManage.vue"),
				meta: {
				  title: "开票记录"
				}
			  },{
				path: 'invoiceCancelManage',
				name: 'invoiceCancelManage',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/invoiceCancelManage.vue"),
				meta: {
				  title: "发票作废"
				}
			  },{
				path: 'invoiceDetails',
				name: 'invoiceDetails',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/invoiceDetails.vue"),
				meta: {
				  title: "查看"
				}
			  },{
				path: 'draweeEnterprise',
				name: 'draweeEnterprise',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/draweeEnterprise.vue"),
				meta: {
				  title: "受票企业"
				}
			  },{
				path: 'IndividualContract',
				name: 'IndividualContract',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/IndividualContract.vue"),
				meta: {
				  title: "个体合同"
				}
			  },{
				path: 'IndividualDetails',
				name: 'IndividualDetails',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/merchantInvoiceManagement/IndividualDetails.vue"),
				meta: {
				  title: "查看"
				}
			  },
			]
		  },{
			path: 'chargeList',
			name: 'chargeList',
			component: () =>
			  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/chargeList.vue"),
			meta: {
			  title: "收费管理"
			},
			children: [{
				path: 'paymentAccount',
				name: 'paymentAccount',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/paymentAccount.vue"),
				meta: {
				  title: "收费账号"
				}
			  },{
				path: 'paymentAccountDetails',
				name: 'paymentAccountDetails',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/paymentAccountDetails.vue"),
				meta: {
				  title: "查看"
				}
			  },{
				path: 'accountLog',
				name: 'accountLog',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/accountLog.vue"),
				meta: {
				  title: "消费记录"
				}
			  },{
				path: 'accountHistory',
				name: 'accountHistory',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/accountHistory.vue"),
				meta: {
				  title: "账号记录"
				}
			  },{
				path: 'fundAudit',
				name: 'fundAudit',
				component: () =>
				  import( /* webpackChunkName: "home" */ "@/page/chargeManagement/fundAudit.vue"),
				meta: {
				  title: "资金审核"
				}
			  },
			]
			},{
				path: 'analysisList',
				name: 'analysisList',
				component: () =>
				import( /* webpackChunkName: "home" */ "@/page/analysisManagement/analysisList.vue"),
				meta: {
				title: "数据分析"
				},
				children: [{
					path: 'billingStatistics',
					name: 'billingStatistics',
					component: () =>
					import( /* webpackChunkName: "home" */ "@/page/analysisManagement/billingStatistics.vue"),
					meta: {
					title: "开票统计"
					}
				},{
					path: 'performanceStatistics',
					name: 'performanceStatistics',
					component: () =>
					import( /* webpackChunkName: "home" */ "@/page/analysisManagement/performanceStatistics.vue"),
					meta: {
					title: "业绩统计"
					}
				},
				]
			}
      ]
    }
  ]
})


router.beforeEach((to, from, next) => {


  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js